export const STAGE_STATE = {
  CURRENT: 'current',
  APPROVED: 'approved',
  PENDING: 'pending',
  BLOCKED: 'blocked',
};

export const ASSIGNEE_STATE = {
  APPROVED: 'approved',
  PENDING: 'pending',
  SKIPPED: 'skipped',
  UNAVAILABLE: 'unavailable',
  LEFT_GROUP: 'left_group',
};

export const APPROVAL_WORKFLOW_QUORUM = {
  ANY: 'any',
  ALL: 'all',
};

export const APPROVAL_PROGRESS_MODE = {
  SIMPLE: 'simple',
  WORKFLOW: 'workflow',
};

// The two proof-level statuses a workflow proof can add to ProofsPage.vue's
// existing approved/rejected/pending/waiting vocabulary.
export const WORKFLOW_PROOF_STATUS = {
  BLOCKED: 'blocked',
  IN_PROGRESS: 'workflow_in_progress',
};
